export default "__VITE_ASSET__a4472347__"